import React from "react";
import { ThisChangesEverything } from "src/components/this-changes-everything";
import { ImageCopy } from "src/components/image-copy";
import { Banner } from "src/components/banner";
import { ProductOffering } from "src/components/product-offering";
import { ReviewsCarousel } from "src/components/reviews-carousel";
import { FeaturedIn } from "src/components/featured-in";
import { MissionStatement } from "src/components/mission-statement";
import { HowItWorks } from "src/components/how-it-works";
import { ProductFeatures } from "src/components/product-features";
import { HereForYou } from "src/components/here-for-you";
import { VideoModule } from "src/components/video-module";

const Modules = ({ type, data }: { type: string; data: any }) => {
  switch (type) {
    case "imageCopyModule":
      return <ImageCopy module={data} />;
    case "bannerModule":
      return <Banner module={data} />;
    case "thisChangesEverythingModule":
      return <ThisChangesEverything module={data} />;
    case "hereForYouModule":
      return <HereForYou module={data} />;
    case "productFeaturesModule":
      return <ProductFeatures module={data} />;
    case "productOfferingModule":
      return <ProductOffering module={data} />;
    case "howItWorksModule":
      return <HowItWorks module={data} />;
    case "featuredInModule":
      return <FeaturedIn module={data} />;
    case "videoModule":
      return <VideoModule module={data} />;
    case "globalSection":
      switch (data.reference._type) {
        case "productOffering":
          return <ProductOffering module={data.reference.module} />;
        case "reviews":
          return <ReviewsCarousel module={data.reference.module} />;
        case "featuredIn":
          return <FeaturedIn module={data.reference.module} />;
        case "missionStatement":
          return <MissionStatement module={data.reference.module} />;
        default:
          return <p className="m1 p1 ac subhead">{data.reference._type}</p>;
      }
    default:
      return <p className="m1 p1 ac subhead">{type}</p>;
  }
};

export const renderModules = (modules: []) => {
  if (modules) {
    return modules.map((module: { _key: string; _type: string }) => {
      return <Modules key={module._key} type={module._type} data={module} />;
    });
  }
};
